/* global axios */
import ApiClient from '../../ApiClient';
import ContactsAPI from '../../contacts';

class VoiceAPI extends ApiClient {
  constructor() {
    super('voice', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  initiateCall(contactId, inboxId) {
    return ContactsAPI.initiateCall(contactId, inboxId).then(r => r.data);
  }

  leaveConference({ inboxId, conversationId, callSid }) {
    return axios
      .delete(`${this.baseUrl()}/inboxes/${inboxId}/conference`, {
        params: { conversation_id: conversationId, call_sid: callSid },
      })
      .then(r => r.data);
  }

  joinConference({ conversationId, inboxId, callSid }) {
    return axios
      .post(`${this.baseUrl()}/inboxes/${inboxId}/conference`, {
        conversation_id: conversationId,
        call_sid: callSid,
      })
      .then(r => r.data);
  }

  getToken(inboxId) {
    if (!inboxId) return Promise.reject(new Error('Inbox ID is required'));
    return axios
      .get(`${this.baseUrl()}/inboxes/${inboxId}/conference/token`)
      .then(r => r.data);
  }

  getSipCredentials(inboxId) {
    return axios
      .get(`${this.baseUrl()}/inboxes/${inboxId}/sip/credentials`)
      .then(r => r.data);
  }

  registerSipCall(inboxId, { sipCallId, from, displayName }) {
    return axios
      .post(`${this.baseUrl()}/inboxes/${inboxId}/sip/calls`, {
        sip_call_id: sipCallId,
        from,
        display_name: displayName,
      })
      .then(r => r.data);
  }

  registerOutboundSipCall(inboxId, { sipCallId, conversationId }) {
    return axios
      .post(
        `${this.baseUrl()}/inboxes/${inboxId}/sip/calls/outbound`,
        { sip_call_id: sipCallId, conversation_id: conversationId }
      )
      .then(r => r.data);
  }

  updateSipCall(inboxId, sipCallId, { status, duration_seconds }) {
    return axios
      .patch(
        `${this.baseUrl()}/inboxes/${inboxId}/sip/calls/${encodeURIComponent(sipCallId)}`,
        { status, duration_seconds }
      )
      .then(r => r.data);
  }
}

export default new VoiceAPI();
